module.exports = __webpack_public_path__ + "img/parnter_work_card.9c48dea1.svg";